import { Languages } from '@/modules/core/enums/languages';
import { IntegrationDefinition } from './integrationDefinition';

export class ProfileModel {
    public email: string;
    public name: string;
    public accountName: string;
    public language: Languages;
    public integrations: IntegrationDefinition[];
    public hasShopifyIntegration: boolean = false;
    public hadShopifyIntegration: boolean = false;
    public defaultPhoneNumberPrefix: string;
    public phoneNumber: string;
    public marketingConsent: boolean;
    public newsletterConsent: boolean;
    public constructor(data?: ProfileModel) {
        this.email = (data && data.email) ? data.email : '';
        this.name = (data && data.name) ? data.name : '';
        this.accountName = (data && data.accountName) ? data.accountName : '';
        this.language = (data && data.language) ? data.language : Languages.EN;
        this.integrations = (data && data.integrations) ? data.integrations : [];
        this.hadShopifyIntegration = (data && data.hadShopifyIntegration) ? data.hadShopifyIntegration : false;
        this.hasShopifyIntegration = this.integrations.some((i) => i.type === 'shopify');
        this.defaultPhoneNumberPrefix = (data && data.defaultPhoneNumberPrefix) ? data.defaultPhoneNumberPrefix : '+48';
        this.phoneNumber = (data && data.phoneNumber) ? data.phoneNumber : '+48';
        this.marketingConsent = (data && data.marketingConsent) ? data.marketingConsent : false;
        this.newsletterConsent = (data && data.newsletterConsent) ? data.newsletterConsent : false;
    }
}
